export enum Scrolled {
  Default = 'Default',
  Reduced = 'Reduced',
  Up = 'Up',
  Down = 'Down',
}
